
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.525 11.657l-4.95-4.95 1.414-1.414 3.654 3.65-.118-.115L14.01.343l1.414 1.414-8.485 8.486-1.413 1.413h-.001z","fill":"var(--brand-primary)"}})])
          )
        }
      }
    